import type { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  action?: ReactNode;
  dashed?: boolean;
}

export function EmptyState({
  icon,
  title = 'Nothing saved yet',
  description,
  action,
  dashed = true,
}: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        border: dashed ? '1px dashed var(--line-strong)' : 'none',
        borderRadius: 'var(--r-lg)',
        padding: '30px 24px',
        textAlign: 'center',
        fontFamily: 'var(--font-body)',
        color: 'var(--text-1)',
      }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 40,
          height: 40,
          borderRadius: 12,
          background: 'var(--surface-1)',
        }}
      >
        {icon || (
          <svg width="18" height="18" viewBox="0 0 16 16" fill="none" stroke="var(--text-3)" strokeWidth="1.5" strokeLinecap="round">
            <rect x="2" y="2.5" width="12" height="3.4" rx="1.4" />
            <rect x="2" y="8" width="12" height="3.4" rx="1.4" opacity={0.6} />
            <path d="M2 14.4h12" opacity={0.35} />
          </svg>
        )}
      </span>
      <span style={{ fontSize: 13, fontWeight: 600 }}>{title}</span>
      {description && <span style={{ fontSize: 11.5, lineHeight: 1.5, color: 'var(--text-2)', maxWidth: 240 }}>{description}</span>}
      {action}
    </div>
  );
}
